<!-- 装车数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index==0">
                <el-form label-width="150px" id="mainInfo" ref="sendDataInfo" label-position="right" :show-message="false" class="demo-form-inline baseForm" :model="sendDataInfo" size="mini">
                  <el-row v-if="dataActionBox.actionType != 2">
                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []" :prop="formOneValue.entityField">
                      <el-input v-if="formOneValue.fieldType == 'extract'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" disabled>
                      </el-input>
                      <el-input :disabled="true" clearable v-else v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                    </el-form-item>
                  </el-row>
                  <el-row v-if="dataActionBox.actionType == 2">
                              <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                 <span v-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                          sendDataInfo[formOneValue.entityField] }}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'date'">
                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                       {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'formatter'">
                                    {{ $common.getIsGsp(formOneValue.formatterContent, sendDataInfo[formOneValue.entityField]) }}
                                 </span>
                                 <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{ sendDataInfo[formOneValue.entityField]
                          == 1 ? "是" : "否" }}</span>
                                 <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                </el-form>
                <el-form>
                  <el-table size="mini" ref="mxTableRef" :data="sendDataInfo.pisOrderMasterVos" border style="width: 100%" :height="mxHeight" v-if="mxForm">
                    <el-table-column v-for="(formOneValue,formOneKey) in formDataList[0].jurconfigform" :min-width="formOneValue.fieldWeight" align="center" show-overflow-tooltip :prop="formOneValue.entityField" :label="formOneValue.showField" :key="formOneKey" v-if="formOneValue.isShow==1">
                    </el-table-column>
                  </el-table>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>

      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import SearchSchemeorderRecord from "../byComponents/SearchSchemeorderRecord.vue";
export default {
  name: "purchaseReceivingRecordAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    SearchSchemeorderRecord,
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 400, //明细表格动态高度
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      selectedDataIndex: 0,
      sendDataInfo: {
        isCold: 0, //是否冷链(0:否，1:是)
        deliveryName: "", //配送员
        deliveryId: '',
        dewmuColdAdd: { //冷链添加信息
          coldControl: '', //温控设备
          coldLoadingTem: '', //	装载环境温度
          coldRemark: "", //备注说明
          coldStrantem: "", //启运温度s
          coldTem: '', //	预冷温度
          coldTimeLimit: '', //	保温时限
          coldTranmode: "", //运输方式
        },
        isTripartite: 0,
        loId: '',
        loName: '', //物流公司
        logisticsNum: '', //物流单号
        logisticsMoney: '', //物流费用
        driverName: "", //司机
        vmLicensecode: "", //车牌号
        transportDetailAddList: [], //装车单明细添加信息
      },
      mainData: [], //普通明细
      detailData: [], //冷链明细
      showTabs: "",
      formDataList: [],
      mxForm: [],
      tabForm: [],
      dictionariesData: {},
      DialogVisible: false, //检索信息
      seId: "",
      seWidth: "",
      seTitle: "",
      searchType: "",
      parentSearchData: {
        opmDriver: 0,
        opmBuyer: '',
      },
      loadingOrderExtractData: {
        coldFlag: 0,
      },
      childPageShowData: [], //子组件的表格头
      loadingRecordVisible: false,
      isLoaded: false,
      isShowDetail: false,
      DialogVisible1: false,
      searchId: "",
      parentSearchData1: {
        cmId: "",
        coId: "",
        opmId: "",
        salesId: "",
        depId: "",
      },
      detailSelectList: [],
      seIndex: 0,
      seType: '',
      sField: ''
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      // this.$nextTick(() => {
      // 	this.nextFocus(this.seIndex)
      // })
    },
    // 获取 提取单数据
    async extract(sendDataInfo) {
      let flag = true
      if (this.sendDataInfo.isTripartite == 0) {
        if (this.sendDataInfo.vmLicensecode == '' || this.sendDataInfo.deliveryName == '' || this.sendDataInfo
          .driverName == '') {
          flag = false
          return this.$message({
            message: "请完善必填信息",
            type: "error",
          });
        }
      } else if (this.sendDataInfo.isTripartite == 1) {
        if (this.sendDataInfo.loName == '' || this.sendDataInfo.logisticsNum == '' || this.sendDataInfo
          .logisticsMoney == '') {
          flag = false
          return this.$message({
            message: "请完善必填信息",
            type: "error",
          });
        }
      }
      if (flag) this.DialogVisible1 = true;
      // this.$refs[sendDataInfo][0].validate((valid) => {
      // 	if (valid) {
      // 		this.DialogVisible1 = true;
      // 	} else {
      // 		this.$message({
      // 			message: "请先选择必填信息",
      // 			type: "warning",
      // 		})
      // 	}
      // });
    },
    //取消
    initActionBox(formName1, formName2) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel");
          this.init();
          this.$refs[formName1].resetFields();
          this.$refs[formName2].resetFields();
        })
        .catch(() => { });
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "dewmuColdAdd") {
          for (let sonOne in this.sendDataInfo[key]) {
            if (sonOne == "coldArrtime" || sonOne == "coldStrantime") {
              this.sendDataInfo[key][sonOne] = this.$moment().valueOf();
            } else {
              this.sendDataInfo[key][sonOne] = "";
            }
          }
        } else if (key == 'isCold' || key == 'isTripartite') {
          this.sendDataInfo[key] = 0
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    //父级传入
    openBox(cate, formData, oldData = "") {
      this.formDataList = formData;
      this.filterMainField()
      this.init();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
        console.log(this.sendDataInfo);
        if (this.sendDataInfo.wobkeInfoList) this.mainData = this.sendDataInfo.wobkeInfoList
        if (this.sendDataInfo.wobkedetailInfoList) this.detailData = this.sendDataInfo.wobkedetailInfoList
        if (dataInfo.dewmuCold) this.sendDataInfo.dewmuColdAdd = dataInfo.dewmuCold
        if (dataInfo.isCold == 0) {
          this.isShowDetail = false
        } else {
          this.isShowDetail = true
        }
      }
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
      this.childPageShowData = [this.formDataList[3], this.formDataList[2]]; //子组件的表格头
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
        }, 100)
      })

    },

    // 获取字典数据
    async getPartDictionariesData() {
      let responseData = await this.$http.getPartDictionariesData({
        ids: [20, 21, 27, 28],
      });
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    //换行提示
    lineMessageBox(data) {
      let txtArr = data.message.split("<br/>");
      let newArr = [];
      const h = this.$createElement;
      for (const i in txtArr) {
        newArr.push(h("p", null, txtArr[i]));
      }
      this.$alert(h("div", null, newArr), "提示", {
        confirmButtonText: "确定",
        callback: (action) => { },
      });
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
        } else if (item.jciType == 2) {
          mainFormList.push(item);
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1)
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = []
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.filterTableData = []
      this.showTabs = mainFormList[0].jciName;
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData;
      this.openBox(params.cate, params.formData, params.oldData);
      this.isLoaded = true;
    });
    this.getPartDictionariesData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    // this.$nextTick(() => {
    //     var sheight = this.$refs.sendDataInfo[0].$el.clientHeight;
    //     if (this.dataActionBox.actionType != 2) {
    //       this.mxHeight = document.documentElement.clientHeight - sheight - 270;
    //     } else {
    //       this.mxHeight = document.documentElement.clientHeight - sheight - 260;
    //     }
    //   });
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}
</style>